import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DynamicTabsPage from "../tabs/tabs"
import apiHelper from '../../utils/apiHelper';
import { EntityType, ContractorService } from '@propertelligent/client-api';
import ContractorCardItem from './ContractorCardItem';
import SimpleSpinner from '../../components/loader';

export const tabs = [
  "Service Requests",
  "Payments",
  "Transactions",
  "Additional Details"
];

const ContractorDetail = () => {
  const { id } = useParams();
  const [ContractorData, setContractorData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [paymentRefreshTrigger, setPaymentRefreshTrigger] = useState(0);

  // Create a memoized function to fetch contractor data
  const fetchContractor = useCallback(() => {
    if (id) {
      setLoading(true);
      apiHelper(ContractorService.getApiContractor, { showNotification: false }, id)
        .then((res) => {
          if (res?.data?.success) {

            setContractorData(res.data.success);
          }
        })
        .catch((err) => {
          console.error("Error fetching contractor:", err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [id]);

  // Fetch data when the component mounts
  useEffect(() => {
    fetchContractor();
  }, [fetchContractor]);


  const handlePaymentAction = () => {
    fetchContractor();
    setPaymentRefreshTrigger(prev => prev + 1);
  };

  if (loading) {
    return <SimpleSpinner myClassName={"Icon50"} isFullPage={true} />;
  }

  return <div className='content-wrapper'>
    {ContractorData ? (
      <ContractorCardItem
        className='contractor-detail-card m-0'
        id={"ContractorDetail"}
        listingData={ContractorData}
        isFooter={true}
        fetchData={fetchContractor}
        disableNavigation={true}
      />
    ) : (
      <></>
    )}

    <DynamicTabsPage
      tabs={tabs}
      defaultActiveTab="Service Requests"
      entityType={EntityType.Contractor}
      isContractor={true}
      contractorPayeeAccountNames={ContractorData?.payeeAccountNames}
      paymentRefreshTrigger={paymentRefreshTrigger}
      onPaymentAction={handlePaymentAction}

      expensesDueRaw={ContractorData?.formatted?.ExpensesDueRaw}
      expensesDue={ContractorData?.formatted?.ExpensesDue}
    />
  </div>
};
export default ContractorDetail;

